<template>
  <div class="t-container">
    <v-row no-gutters dense>
      <v-col cols="12" class="wrap-msg">
        <span v-html="msg"></span>
      </v-col>
      <v-col cols="12" class="wrap-submsg">
        <span v-if="submsg" v-html="submsg"></span>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: ['msg', 'submsg'],
  methods: {
    clicked() {
      // Emit a "click" event when clicked.
      // Can be any event though and even pass parameters back
      this.$emit('click')
    },
  },
}
</script>

<style>
.t-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.action {
  height: 40px;
  padding: 5px 10px;
  border-radius: 5px;
  color: white;
  cursor: pointer;
  border: thin solid currentColor;
}
.Vue-Toastification__container {
  z-index: 9999999 !important;
}
.Vue-Toastification__toast--success {
  background-color: rgb(40, 144, 103) !important;
  border: 1px solid rgba(255, 255, 255, 0.1);
}
.Vue-Toastification__toast--error {
  background-color: #d4424a !important;
  border: 1px solid rgba(255, 255, 255, 0.1);
}
.Vue-Toastification__toast--default {
  background-color: rgba(14, 21, 25, 1) !important;
  border: 1px solid rgba(255, 255, 255, 0.1);
}
.wrap-msg span {
  font-size: 14px !important;
}
.wrap-submsg span {
  font-size: 12px !important;
}
.Vue-Toastification__progress-bar {
  background-color: rgba(255, 255, 255, 0.33) !important;
}
@keyframes fadeIn {
  from {
    opacity: 1;
    height: 0;
    max-height: 0px;
    min-height: 0px;
    padding: 0px 24px;
  }
  to {
    opacity: 1;
    height: auto;
    max-height: 800px;
    min-height: 64px;
    padding: 22px 24px;
  }
}
@keyframes fadeOut {
  0% {
    opacity: 1;
    height: auto;
    max-height: 800px;
    min-height: 64px;
    padding: 22px 24px;
  }
  100% {
    opacity: 0;
    height: 0;
    max-height: 0px;
    min-height: 0px;
    padding: 0px 24px;
  }
}
.fade-enter-active {
  animation-name: fadeIn;
}
.fade-leave-active {
  animation-name: fadeOut;
}
.fade-move {
  transition-timing-function: linear;
  transition-property: all;
  transition-duration: 50ms;
}

@keyframes zoom-in-zoom-out {
  0% {
    transform: scale(1, 1);
  }
  50% {
    transform: scale(1.05, 1.05);
  }
  100% {
    transform: scale(1, 1);
  }
}

.zoom-in-out-box {
  animation: zoom-in-zoom-out 0.3s ease-in-out 1;
}
</style>
